module.exports = __webpack_public_path__ + "media/Chapter4AudioLoop.e0f9966f.mp3";